import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import {TranslateModule} from '@ngx-translate/core';
import { HeaderComponent } from './header/header/header.component';
import { FooterComponent } from './footer/footer/footer.component';

@NgModule({
      declarations: [ HeaderComponent, FooterComponent ],
      imports: [
            CommonModule,
            MatExpansionModule,
            FormsModule,
            ReactiveFormsModule,
            TranslateModule,
      ],
      exports:[HeaderComponent, FooterComponent]
})
export class LayoutCustomModule { }
